!function(){"use strict";if(!window.__popbarCartBridgeInstalled){window.__popbarCartBridgeInstalled=!0;var r=/\/cart\/add(\.js)?(\?|$)/,e=/[?&]bridge=skip(&|$)/,o=window.fetch;"function"==typeof o&&(window.fetch=function(t,p){try{var a="string"==typeof t?t:t&&t.url||"";if(r.test(a)&&p&&null!=p.body)if(function(r,o){if(e.test(r))return!0;if(!o||null==o.body)return!1;if("string"!=typeof o.body)return!1;try{var t=JSON.parse(o.body);if(t&&t.properties&&Object.prototype.hasOwnProperty.call(t.properties,"_linked_to"))return!0;if(t&&Array.isArray(t.items))for(var p=0;p<t.items.length;p++){var a=t.items[p];if(a&&a.properties&&Object.prototype.hasOwnProperty.call(a.properties,"_linked_to"))return!0}}catch(r){}return!1}(a,p))console.log("[popbar-cart-bridge] skipped companion POST "+a);else{var i=document.querySelector(".popbar-flavor-picker__hidden-lips");if(i){var n=i.querySelectorAll('input[name^="properties"]');if(p.body instanceof FormData){var s=0;n.forEach(function(r){p.body.has(r.name)||(p.body.append(r.name,r.value),s++)}),s>0&&console.log("[popbar-cart-bridge] Injected "+s+" FormData properties into "+a)}else if("string"==typeof p.body)try{var c=JSON.parse(p.body);c.properties=c.properties||{};var d=0;n.forEach(function(r){var e=r.name.match(/^properties\[(.+)\]$/),o=e?e[1]:r.name;void 0===c.properties[o]&&(c.properties[o]=r.value,d++)}),d>0&&(p.body=JSON.stringify(c),console.log("[popbar-cart-bridge] Injected "+d+" JSON properties into "+a))}catch(r){try{var l=new URLSearchParams(p.body),b=0;n.forEach(function(r){l.has(r.name)||(l.append(r.name,r.value),b++)}),b>0&&(p.body=l.toString(),console.log("[popbar-cart-bridge] Injected "+b+" URLencoded properties into "+a))}catch(r){console.log("[popbar-cart-bridge] unsupported string body shape; skipped")}}else console.log("[popbar-cart-bridge] unsupported body type: "+typeof p.body+"; skipped")}}}catch(r){console.log("[popbar-cart-bridge] interceptor error (non-fatal): "+r.message)}return o.apply(this,arguments)},console.log("[popbar-cart-bridge] v1.1.0 installed"))}}();

/* Above-the-fold jump CTA (added 2026-09-21): the picker owns the only
   add-to-cart and renders far below the fold, so the buy column was empty. */
(function(){
  function addJump(){
    if(!document.body.classList.contains('popbar-has-picker')) return;
    if(document.querySelector('.popbar-jump-cta')) return;
    var picker=document.getElementById('popbar-picker')||document.querySelector('.popbar-flavor-picker');
    if(!picker) return;
    var slot=document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if(!slot) return;
    var a=document.createElement('a');
    a.className='popbar-jump-cta';
    a.href='#popbar-picker';
    a.textContent='Choose your flavors \u2193';
    a.addEventListener('click',function(e){
      e.preventDefault();
      picker.scrollIntoView({behavior:'smooth',block:'start'});
    });
    slot.appendChild(a);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',addJump);}else{addJump();}
  setTimeout(addJump,1200);
})();


/* Mobile sticky buy bar (added 2026-09-21). */
(function(){
  function initSticky(){
    if(!document.body.classList.contains('popbar-has-picker')) return;
    if(document.querySelector('.popbar-sticky-buy')) return;
    if(window.matchMedia('(min-width:750px)').matches) return;
    var picker=document.getElementById('popbar-picker')||document.querySelector('.popbar-flavor-picker');
    if(!picker) return;
    var bar=document.createElement('div');
    bar.className='popbar-sticky-buy';
    var a=document.createElement('a');
    a.href='#popbar-picker';
    a.textContent='Choose your flavors \u2193';
    a.addEventListener('click',function(e){e.preventDefault();picker.scrollIntoView({behavior:'smooth',block:'start'});});
    bar.appendChild(a); document.body.appendChild(bar);
    function sync(){
      var r=picker.getBoundingClientRect();
      var pickerVisible = r.top < window.innerHeight*0.85 && r.bottom > 0;
      bar.classList.toggle('is-on', !pickerVisible);
    }
    sync();
    window.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSticky);}else{initSticky();}
  setTimeout(initSticky,1400);
})();
